import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ErliaThemeProvider } from '@shared/contexts';
import { MessageCounterProvider } from '@shared/contexts/MessageCounterContext';
import { Toaster } from '@ui';
import { AuthProvider } from '@feature/auth';
import { RootLayout } from './app';
import { initSentry } from '@shared/lib/sentry';
import { SentryErrorBoundary } from '@shared/components/SentryErrorBoundary';

// Inicializar Sentry antes que cualquier otra cosa
initSentry();

window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('chunk-reload-at') ?? 0);
  if (Date.now() - lastReload < 10000) return;
  event.preventDefault();
  sessionStorage.setItem('chunk-reload-at', String(Date.now()));
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary>
      <ErliaThemeProvider>
        <MessageCounterProvider>
          <AuthProvider>
            <RootLayout />
            <Toaster />
          </AuthProvider>
        </MessageCounterProvider>
      </ErliaThemeProvider>
    </SentryErrorBoundary>
  </StrictMode>,
)
